import React, { useEffect, useRef, useState } from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import "../Calender/calender.css"

const EventCalendar = () => {
  const [date, setDate] = useState(new Date());
  const calendarRef = useRef(null);

  useEffect(() => {
    if (calendarRef.current) {
      const focusableElements = calendarRef.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      focusableElements.forEach(el => {
        el.tabIndex = -1; 
      });
    }
  }, []);

  return (
    <div ref={calendarRef}>
      <Calendar value={date} />
    </div>
  );
};

export default EventCalendar;